import { SetStateAction, useContext, useEffect, useState, useRef } from "react";
import { Button, IconButton, MenuItem, Paper, Select, Snackbar, TableContainer, TextField, Toolbar, Typography } from "@mui/material";
import React from "react";
import { CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { useLocation } from "react-router-dom";
import { del, get, post, post_file } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { Alert } from "../../../Components/Alert/Alert";
import LoadingVulpesSmall from "../../../Styles/Loader/loadingSmall";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { ICabecalho4 } from "../../../Interfaces/cadernos/caderno4";
import BasicPopover from "../../../Components/Popover";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Modalshowpdf } from "../../../Components/VerPdf/modal_show_pdf";

interface CabecalhoForm_prop {
  set_obj_anexo_cabecalho_selecionado: React.Dispatch<SetStateAction<ICabecalho4 | undefined>>;
  obj_anexo_cabecalho_selecionado: ICabecalho4 | undefined;
}

export const CabecalhoForm: React.FC<CabecalhoForm_prop> = ({
  obj_anexo_cabecalho_selecionado
  , set_obj_anexo_cabecalho_selecionado }) => {
  const auth = useContext(AuthContext);


  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IZonaHomogenea>();
  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IZonaHomogenea[]>([]);
  const [cultura_selecionada, set_cultura_selecionada] = useState<any>();

  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<ICabecalho4>();
  const [obj_anexo_cabecalho_lista, set_obj_anexo_cabecalho_lista] = useState<ICabecalho4[]>();
  const [obj_anexo_cabecalho_to_edit, set_obj_anexo_cabecalho_to_edit] = useState<ICabecalho4>();

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [flag_editar_cabecalho, set_flag_editar_cabecalho] = useState(false)
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [error_producao_total, set_error_producao_total] = React.useState(false);
  const [error_esperada, set_error_esperada] = React.useState(false);
  const [error_obtidas, set_error_obtidas] = React.useState(false);
  const [error_n_plantas, set_error_n_plantas] = React.useState(false);
  const [error_biocidas, set_error_biocidas] = React.useState(false);

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const [isEditingCultura, setIsEditingCultura] = useState(false);

  const handleCloseDialog = () => {
    set_error_esperada(false)
    set_error_biocidas(false)
    set_error_obtidas(false)
    set_error_producao_total(false)
    set_error_n_plantas(false)
    set_flag_editar_cabecalho(false)
    set_flag_editado(false)
    set_obj_anexo_cabecalho_to_edit(undefined)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState("");
  const [open_dialog_eliminar_ficheiro, set_open_dialog_eliminar_ficheiro] = useState(false);
  const [open_dialog_editar_ficheiro, set_open_dialog_editar_ficheiro] = useState(false);
  const [open_modal_show_pdf, set_open_modal_show_pdf] = useState(false);
  const [pdf_link, set_pdf_link] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const uploadDocumento = async (selectedFile: File) => {
    if (!selectedFile) {
      setMessage("Nenhum ficheiro selecionado.");
      setOpenSnackError(true);
      return;
    }

    if (!obj_anexo_cabecalho || !obj_anexo_cabecalho.id_registo_fitocabe) {
      setMessage("Impossível carregar o documento antes de criar cabeçalho.");
      setOpenSnackError(true);
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await post_file(auth.token.cookie_token, `/uploadFile4/${obj_anexo_cabecalho?.id_registo_fitocabe}`, formData);

      if (response.status === 200) {
        setMessage("Documento carregado com sucesso!");
        setOpenSnackSuccess(true);
        // setSelectedFile(selectedFile)
        setFileName(response.data.result.file)
        setSelectedFile(new File([], response.data.result.file, { type: 'application/pdf' }));

        let aux = obj_anexo_cabecalho_lista?.map((el) => {
          if (el.id_registo_fitocabe === response.data.result.id_registo_fitocabe) {
            return response.data.result
          } else {
            return el
          }
        })

        set_obj_anexo_cabecalho_lista(aux)
      } else {
        setMessage("Erro ao carregar documento.");
        setOpenSnackError(true);
      }
    } catch (error: any) {
      func_print("uploadDocumento", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setIsLoading(false);
      setOpenSnackError(true);
    } finally {
      setIsLoading(false);
    }

  };

  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type } = event.target;
    let aux_obj_anexo: any = obj_anexo_cabecalho_to_edit === undefined ? {} : obj_anexo_cabecalho_to_edit
    set_flag_editado(true)

    if (type === "checkbox") {
      aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
      set_obj_anexo_cabecalho_to_edit(aux_obj_anexo);

    } else {
      if (name === 'producao_total') {
        if (!/^\d+$/.test(value)) {
          set_error_producao_total(true)
        } else {
          set_error_producao_total(false)
        }
      }
      if (name === 'esperada') {
        if (!/^\d+$/.test(value)) {
          set_error_esperada(true)
        } else {
          set_error_esperada(false)
        }
      }
      if (name === 'obtidas') {
        if (!/^\d+$/.test(value)) {
          set_error_obtidas(true)
        } else {
          set_error_obtidas(false)
        }
      }
      if (name === 'n_plantas') {
        if (!/^\d+$/.test(value)) {
          set_error_n_plantas(true)
        } else {
          set_error_n_plantas(false)
        }
      }
      if (name === 'biocidas') {
        if (value.trim() === "") {
          set_error_biocidas(true)
        } else {
          set_error_biocidas(false)
        }
      }
      set_obj_anexo_cabecalho_to_edit((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
  };

  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };

  const atualizarListaZonasComCabecalhos = (
    listaZonas: any[],
    listaCabecalhos: ICabecalho4[]
  ) => {
    const resultado = listaZonas.map((zona) => ({
      ...zona,
      culturas: [...(zona.culturas ?? [])],
    }));

    listaCabecalhos.forEach((item: ICabecalho4) => {
      const zona = resultado.find(
        (z) => z.zona_homogenea === item.zona_homo
      );

      const novaCultura = {
        cultura: item.cultura,
        area: item.area,
      };

      if (!zona) {
        resultado.push({
          zona_homogenea: item.zona_homo,
          culturas: [novaCultura],
        });
      } else {
        const culturaExiste = zona.culturas.some(
          (c: any) => c.cultura === item.cultura
        );

        if (!culturaExiste) {
          zona.culturas.push(novaCultura);
        }
      }
    });

    return resultado;
  };
  const get_info = async () => {
    try {
      let res = await get(auth.token.cookie_token,
        `/zona_homgenea_caraterizacao/${location.state.id_rosto}`
        // `/get_reg_anexo_um__cabecalho_rosto/${location.state.id_rosto}`
      );
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_fitossanitaria_cabecalho__rosto/${location.state.id_rosto}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );
      if (res.status === 200 && res_cabecalho.status === 200) {
        if (res.data.result.length !== 0) {

          const resultado = atualizarListaZonasComCabecalhos(
            res.data.result,
            res_cabecalho.data.result
          );


          set_especie_ou_lote_homegenio_lista(resultado);
          set_especie_ou_lote_homegenio_selecionada(resultado[0])
          set_cultura_selecionada(resultado[0].culturas[0])

          if (res_cabecalho.data.result.length !== 0) {
            set_obj_anexo_cabecalho_lista(res_cabecalho.data.result)
            set_obj_anexo_cabecalho_selecionado(res_cabecalho.data.result.find((el: ICabecalho4) => el.zona_homo === resultado[0].zona_homogenea))
            let obj_aux = res_cabecalho.data.result?.find((el: ICabecalho4) => el.zona_homo === resultado[0].zona_homogenea)
            if (obj_aux === undefined) {

              set_flag_editar_cabecalho(true)

            } else {
              set_obj_anexo_cabecalho_to_edit(obj_aux)
              set_obj_anexo_cabecalho(obj_aux)

              set_cultura_selecionada(resultado[0].culturas.find((el: any) => el.cultura === obj_aux.cultura))



              if (obj_aux.file) {
                setFileName(obj_aux.file)
                setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
              }
            }

          } else {
            set_flag_editar_cabecalho(true)

          }
        }
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);

      setIsLoading(false);
    }
  };
  const handle_change_cultura = (cultura_selecionad: string) => {

    let aux_cultura_selecionada = especie_ou_lote_homegenio_selecionada?.culturas.find((el: any) => el.cultura === cultura_selecionad)

    set_cultura_selecionada(aux_cultura_selecionada)

    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho4) => el.zona_homo === especie_ou_lote_homegenio_selecionada?.zona_homogenea && aux_cultura_selecionada.cultura === el.cultura)

    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      setFileName('')
      setSelectedFile(null);
    } else {
      set_flag_editar_cabecalho(false)

      if (obj_aux.file) {
        setFileName(obj_aux.file)
        setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
      } else {
        setFileName('')
        setSelectedFile(null);
      }
    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)

  }

  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)
    const listaZonasAtualizada = atualizarListaZonasComCabecalhos(
      especie_ou_lote_homegenio_lista ?? [],
      obj_anexo_cabecalho_lista ?? []
    );

    set_especie_ou_lote_homegenio_lista(listaZonasAtualizada);

    let aux_obj_zona_homogenea_selecionada = listaZonasAtualizada.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho4) => el.zona_homo === zona_homogenea_selecionada)
    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      setFileName('')
      setSelectedFile(null);
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas[0])
    } else {
      set_flag_editar_cabecalho(false)

      if (obj_aux.file) {
        setFileName(obj_aux.file)
        setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
      } else {
        setFileName('')
        setSelectedFile(null);
      }
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas.find((el: any) => el.cultura === obj_aux?.cultura))
    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)
    set_error_biocidas(false)


  }

  const handle_criar_cabecalho = async () => {
    if (obj_anexo_cabecalho_to_edit?.biocidas === undefined || obj_anexo_cabecalho_to_edit?.biocidas.trim() === "") {
      set_error_biocidas(true)
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      return
    }

    if (error_producao_total || error_esperada || error_obtidas || error_n_plantas || error_biocidas) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {

      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "new_reg_fitossanitaria_cabecalho", {
          payload: {
            id_registo_fitocabe: 0,
            zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            tipo_rega: obj_anexo_cabecalho_to_edit?.tipo_rega === undefined ? null : obj_anexo_cabecalho_to_edit?.tipo_rega,
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            producao_total: obj_anexo_cabecalho_to_edit?.producao_total === undefined ? null : obj_anexo_cabecalho_to_edit?.producao_total,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            biocidas: obj_anexo_cabecalho_to_edit?.biocidas === undefined ? null : obj_anexo_cabecalho_to_edit?.biocidas,
            obtidas: obj_anexo_cabecalho_to_edit?.obtidas === undefined ? null : obj_anexo_cabecalho_to_edit?.obtidas,
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            n_plantas: obj_anexo_cabecalho_to_edit?.n_plantas === undefined ? null : obj_anexo_cabecalho_to_edit?.n_plantas,
            data_platacao: obj_anexo_cabecalho_to_edit?.data_platacao === undefined ? null : obj_anexo_cabecalho_to_edit?.data_platacao,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })
        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          if (obj_anexo_cabecalho_lista?.length === 0 || obj_anexo_cabecalho_lista === undefined) {
            set_obj_anexo_cabecalho_lista([data.data.result])

          } else {
            set_obj_anexo_cabecalho_lista((old: any) => [...old, data.data.result])

          }
          set_error_biocidas(false)
          set_error_esperada(false)
          set_error_obtidas(false)
          set_error_producao_total(false)
          set_error_n_plantas(false)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_flag_editar_cabecalho(false)
          set_flag_editado(false)


          if (data.data.result.file) {
            setFileName(data.data.result.file)
            setSelectedFile(new File([], data.data.result.file, { type: 'application/pdf' }));
          } else {
            setFileName('')
            setSelectedFile(null);
          }

        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error) {
        func_print('handle_criar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }
  }

  const handle_editar_cabecalho = async () => {
    if (obj_anexo_cabecalho_to_edit?.biocidas === undefined || obj_anexo_cabecalho_to_edit?.biocidas.trim() === "") {
      set_error_biocidas(true)
    }

    if (error_obtidas || error_esperada || error_producao_total || error_n_plantas || error_biocidas) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "update_reg_fitossanitaria_cabecalho", {
          payload: {


            id_registo_fitocabe: obj_anexo_cabecalho_to_edit?.id_registo_fitocabe === undefined ? null : obj_anexo_cabecalho_to_edit?.id_registo_fitocabe,
            zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            tipo_rega: obj_anexo_cabecalho_to_edit?.tipo_rega === undefined ? null : obj_anexo_cabecalho_to_edit?.tipo_rega,
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            producao_total: obj_anexo_cabecalho_to_edit?.producao_total === undefined ? null : obj_anexo_cabecalho_to_edit?.producao_total,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            biocidas: obj_anexo_cabecalho_to_edit?.biocidas === undefined ? null : obj_anexo_cabecalho_to_edit?.biocidas,
            obtidas: obj_anexo_cabecalho_to_edit?.obtidas === undefined ? null : obj_anexo_cabecalho_to_edit?.obtidas,
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            n_plantas: obj_anexo_cabecalho_to_edit?.n_plantas === undefined ? null : obj_anexo_cabecalho_to_edit?.n_plantas,
            data_platacao: obj_anexo_cabecalho_to_edit?.data_platacao === undefined ? null : obj_anexo_cabecalho_to_edit?.data_platacao,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })


        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editar_cabecalho(false)
          set_error_esperada(false)
          set_error_biocidas(false)
          set_error_obtidas(false)
          set_error_producao_total(false)
          set_error_n_plantas(false)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_flag_editado(false)


          let aux = obj_anexo_cabecalho_lista?.map((el) => {
            if (el.id_registo_fitocabe === data.data.result.id_registo_fitocabe) {
              return data.data.result
            } else {
              return el
            }
          })
          set_obj_anexo_cabecalho_lista(aux)
          if (data.data.result.file) {
            setFileName(data.data.result.file)
            setSelectedFile(new File([], data.data.result.file, { type: 'application/pdf' }));
          } else {
            setFileName('')
            setSelectedFile(null);
          }
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print('handle_editar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }
  const handle_delete_cabecalho = async () => {
    try {
      setIsLoading(true);
      let data = await del(auth.token.cookie_token, `delete__reg_fitossanitaria_cabecalho/${obj_anexo_cabecalho?.id_registo_fitocabe}`)
      if (data.status === 200) {
        set_open_dialog_tem_a_certeza_que_quer_eliminar(false)
        func_print('obj_anexo_cabecalho_lista', obj_anexo_cabecalho_lista)
        let lista_aux: any = obj_anexo_cabecalho_lista?.filter((el) => el.id_registo_fitocabe !== obj_anexo_cabecalho?.id_registo_fitocabe)
        setMessage("Eliminado com sucesso!");
        setOpenSnackSuccess(true);
        set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho_selecionado(undefined)
        set_obj_anexo_cabecalho(undefined)
        set_obj_anexo_cabecalho_to_edit(undefined)
        set_flag_editar_cabecalho(true)
        setSelectedFile(null)
        setFileName('')

      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {

      func_print('handle_delete_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
    }
  }

  const handleEdit = () => {
    set_open_dialog_editar_ficheiro(true);
  };

  const handleConfirmEdit = () => {
    set_open_dialog_editar_ficheiro(false);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDelete = () => {
    set_open_dialog_eliminar_ficheiro(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsLoading(true);

      const payload = {
        payload: {
          ...obj_anexo_cabecalho,
        }
      };

      const response = await post(auth.token.cookie_token,
        `/update_file_reg_fitossanitaria_cabecalho`,
        payload
      );

      if (response.status === 200) {
        setSelectedFile(null);
        setFileName("");
        set_open_dialog_eliminar_ficheiro(false);
        setMessage("Documento eliminado com sucesso!");
        setOpenSnackSuccess(true);
        let aux = obj_anexo_cabecalho_lista?.map((el) => {
          if (el.id_registo_fitocabe === response.data.result.id_registo_fitocabe) {
            return response.data.result
          } else {
            return el
          }
        })

        set_obj_anexo_cabecalho_lista(aux)

      } else {
        setMessage("Erro ao eliminar o documento!");
        setOpenSnackError(true);
      }
    } catch (error) {
      func_print('handleConfirmDelete', error, true);
      setMessage("Erro ao eliminar o documento!");
      setOpenSnackError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewDocument = () => {
    if (selectedFile) {
      set_pdf_link(fileName);
      set_open_modal_show_pdf(true);
    }
  };

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);




  return (
    <form>
      <CustomThemeProvider>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {isLoading ?
            <LoadingVulpesSmall />
            :
            <Toolbar
              style={{
                paddingTop: 3,
                paddingBottom: 10,
                fontFamily: "candara",
                display: "flex",
                flexDirection: 'column',
              }}
            >
              <div style={{
                width: '100%',
                display: "flex",
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingBottom: 10
              }}>
                <div style={{
                  display: "flex",
                  flexDirection: 'row',
                }}>
                  <h1 style={{
                    fontWeight: 600,
                    fontSize: 20,
                    fontFamily: "candara",
                  }}>
                    4 - Registo de Proteção Fitossanitária
                  </h1>
                  <BasicPopover
                    text={"Your help text here"}
                  />
                </div>

                <div>
                  {obj_anexo_cabecalho === undefined ? <></> : selectedFile === null ?

                    is_historico === true ? <></> :
                      <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<FileUploadIcon />}
                        style={{
                          backgroundColor: cores.cor1,
                          maxHeight: 30,
                          width: 250,
                          marginRight: 10
                        }}
                      >
                        Carregar documento
                        <input
                          type="file"
                          accept="application/pdf"
                          hidden
                          multiple={false}
                          onChange={(event) => {
                            const file = event.target.files?.[0];
                            if (file) {
                              uploadDocumento(file);
                            }
                          }}
                        />
                      </Button>
                    :
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Button
                        style={{
                          backgroundColor: cores.cor1,
                          color: 'white',
                          maxHeight: 30,
                          width: 200,
                        }}
                        startIcon={<VisibilityIcon />}
                        onClick={handleViewDocument}
                      >
                        Ver documento
                      </Button>
                      {
                        is_historico === true ? <></> :
                          <>
                            <Button
                              style={{
                                backgroundColor: cores.cor1,
                                color: 'white',
                                minWidth: '40px',
                                maxHeight: 30,
                              }}
                              onClick={handleEdit}
                            >
                              <FileUploadIcon />
                            </Button>
                            <Button
                              style={{
                                backgroundColor: cores.cor1,
                                color: 'white',
                                minWidth: '40px',
                                maxHeight: 30,
                              }}
                              onClick={handleDelete}
                            >
                              <DeleteIcon />
                            </Button>
                            <input
                              ref={fileInputRef}
                              type="file"
                              accept="application/pdf"
                              hidden
                              multiple={false}
                              onChange={(event) => {
                                const file = event.target.files?.[0];
                                if (file) {
                                  uploadDocumento(file);
                                }
                              }}
                            />
                          </>
                      }

                    </div>
                  }
                </div>
              </div>
              <div style={{
                width: '100%',
                display: "flex",
                flexDirection: 'row',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
              }}>
                {
                  is_historico === true ? <></> :


                    especie_ou_lote_homegenio_lista.length === 0 ? <></> :

                      obj_anexo_cabecalho === undefined ?

                        <ButtonCadernos
                          mostrarBotaoGravar
                          aoClicarGravar={() => { handle_criar_cabecalho() }}
                        />
                        :
                        flag_editar_cabecalho === true ?
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                set_error_esperada(false)
                                set_error_biocidas(false)
                                set_error_obtidas(false)
                                set_error_producao_total(false)
                                set_error_n_plantas(false)
                                set_flag_editar_cabecalho(false)
                              }
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_editar_cabecalho() }}
                          /> :
                          <ButtonCadernos
                            mostrarBotaoApagar
                            mostrarBotaoEditar
                            aoClicarApagar={() => {
                              set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                              set_error_biocidas(false)
                            }}
                            aoClicarEditar={() => { set_flag_editar_cabecalho(true) }}
                          />

                }
              </div>
              <div style={{
                display: "flex",
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
              }}>
                <div style={{
                  display: "flex",
                  flex: 0.25,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  Zona Homogénea:
                  <Select
                    value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                    label={''}
                    name={'zona_homogenea'}
                    sx={{
                      fontSize: 14,
                      fontFamily: "verdana",
                      minWidth: 200,
                    }}
                    onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                  >
                    {especie_ou_lote_homegenio_lista.sort((a, b) =>
                      (a.zona_homogenea?? '').localeCompare(b.zona_homogenea?? '', 'pt', {
                        sensitivity: 'base',
                      })
                    ).map((item: IZonaHomogenea, key) => (
                      <MenuItem key={key} value={item.zona_homogenea}>
                        <Typography
                          style={{
                            fontSize: 14,
                            fontFamily: "candara",
                          }}
                        >
                          {item.zona_homogenea}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.15,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  Área (ha): {cultura_selecionada?.area === undefined ? '' : cultura_selecionada?.area.toFixed(2)}
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.30,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  marginRight: '2%',
                }}>
                  Tipo de rega:
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      name="tipo_rega"
                      value={obj_anexo_cabecalho_to_edit?.tipo_rega === undefined ? '' : obj_anexo_cabecalho_to_edit?.tipo_rega}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.tipo_rega === undefined ? '' : obj_anexo_cabecalho?.tipo_rega}
                    </div>
                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.30,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  <BasicPopover
                    text={"Campo de preenchimento obrigatório para efeito de cumprimento do indicador 1,5, da área 1, do RLG 5 da Portaria n.º 54-Q/2023."}
                  />
                  Se aplica biocidas nas áreas de passagem ou instalações não destinadas à quarda de produtos vegetais indicar o local:*
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      name="biocidas"
                      value={obj_anexo_cabecalho_to_edit?.biocidas === undefined ? '' : obj_anexo_cabecalho_to_edit?.biocidas}
                      onChange={onInputEditTableChange_cabecalho}
                      error={error_biocidas}
                      helperText={error_biocidas ? 'Campo obrigatório' : ""}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.biocidas === undefined ? '' : obj_anexo_cabecalho?.biocidas}
                    </div>
                  }
                </div>
              </div>
              <div style={{
                display: "flex",
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
              }}>
                <div style={{
                  display: "flex",
                  flex: 0.2,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  gap: 8,
                  border: '1px solid silver',
                  padding: 8,
                  borderRadius: 5,
                }}>
                  <BasicPopover
                    text={"Condicionalidade: campo de preenchimento obrigatório para efeito do cumprimento do indicador 1.4, da área 1, do RLG 5 da Portaria n.º 54-Q/2023."}
                  />

                  Cultura e variedade:*

                  {!isEditingCultura ? (
                    <Select
                      value={cultura_selecionada?.cultura ?? ''}
                      name={'cultura'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => {
                        handle_change_cultura(e.target.value)
                      }}
                    >
                      {especie_ou_lote_homegenio_selecionada?.culturas
                        .sort((a, b) =>
                          (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                            sensitivity: 'base',
                          })
                        )
                        .map((item: any, key) => (
                          <MenuItem key={key} value={item.cultura}>
                            <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                              {item.cultura}
                            </Typography>
                          </MenuItem>
                        ))}
                    </Select>
                  ) : (
                    <CustomTextField
                      name="cultura"
                      minWidth={200}
                      value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                      onChange={(e: any) => {

                        set_especie_ou_lote_homegenio_selecionada((old: any) => ({
                          ...old,
                          culturas: old.culturas.map((el: any) => {
                            if (el.cultura === cultura_selecionada?.cultura) {
                              return {
                                ...el,
                                cultura: e.target.value,
                              }
                            } else {
                              return el
                            }
                          })
                        }))
                        set_cultura_selecionada((old: any) => ({
                          ...old,
                          cultura: e.target.value,
                        }))
                      }}
                    />
                  )}

                  <div style={{
                    display: "flex"
                    // , alignSelf: "flex-start",
                  }}>
                    {
                      flag_editar_cabecalho === false ? <></> :
                        isEditingCultura ?
                          <ButtonCadernos
                            mostrarBotaoGravar
                            aoClicarGravar={() => { setIsEditingCultura(prev => !prev) }}
                          />
                          :
                          <ButtonCadernos
                            mostrarBotaoEditar

                            aoClicarEditar={() => { setIsEditingCultura(prev => !prev) }}
                          />
                    }


                  </div>
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.2,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  marginRight: '2%',
                }}>
                  Compasso:
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      name="compasso"
                      value={obj_anexo_cabecalho_to_edit?.compasso === undefined ? '' : obj_anexo_cabecalho_to_edit?.compasso}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.compasso === undefined ? '' : obj_anexo_cabecalho?.compasso}
                    </div>
                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.2,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  marginRight: '2%',
                }}>
                  Porta-enxerto:
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      disabled={!flag_editar_cabecalho}
                      name="porta_enxerto"
                      value={obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho_to_edit?.porta_enxerto}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho?.porta_enxerto}
                    </div>
                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.2,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  marginRight: '2%',
                }}>
                  nº de plantas:
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      name="n_plantas"
                      value={obj_anexo_cabecalho_to_edit?.n_plantas === undefined ? '' : obj_anexo_cabecalho_to_edit?.n_plantas}
                      onChange={onInputEditTableChange_cabecalho}
                      error={error_n_plantas}
                      helperText={error_n_plantas ? 'Apenas números são aceites' : ""}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.n_plantas === undefined ? '' : obj_anexo_cabecalho?.n_plantas}
                    </div>
                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.2,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  Data de plantação ou de sementeira:
                  {flag_editar_cabecalho === true ?
                    <TextField
                      variant="filled"
                      type="date"
                      defaultValue={obj_anexo_cabecalho_to_edit?.data_platacao}
                      disabled={!flag_editar_cabecalho}
                      name="data_platacao"
                      value={obj_anexo_cabecalho_to_edit?.data_platacao === undefined ? '' : obj_anexo_cabecalho_to_edit?.data_platacao}
                      onChange={onInputEditTableChange_cabecalho}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.data_platacao === undefined ? '' : obj_anexo_cabecalho?.data_platacao}
                    </div>
                  }
                </div>
              </div>
              <div style={{
                display: "flex",
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
              }}>
                <div style={{
                  display: "flex",
                  flex: 0.33,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  marginRight: '2%',
                }}>
                  Produção total:
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      disabled={!flag_editar_cabecalho}
                      name="producao_total"
                      value={obj_anexo_cabecalho_to_edit?.producao_total === undefined ? '' : obj_anexo_cabecalho_to_edit?.producao_total}
                      onChange={onInputEditTableChange_cabecalho}
                      error={error_producao_total}
                      helperText={error_producao_total ? 'Apenas números são aceites' : ""}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.producao_total === undefined ? '' : obj_anexo_cabecalho?.producao_total}
                    </div>
                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.33,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  marginRight: '2%',
                }}>
                  Esperada (Ton/ha):
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      disabled={!flag_editar_cabecalho}
                      name="esperada"
                      value={obj_anexo_cabecalho_to_edit?.esperada === undefined ? '' : obj_anexo_cabecalho_to_edit?.esperada}
                      onChange={onInputEditTableChange_cabecalho}
                      error={error_esperada}
                      helperText={error_esperada ? 'Apenas números são aceites' : ""}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.esperada === undefined ? '' : obj_anexo_cabecalho?.esperada}
                    </div>
                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 0.33,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  Obtida (Ton/ha):
                  {flag_editar_cabecalho === true ?
                    <CustomTextField
                      disabled={!flag_editar_cabecalho}
                      name="obtidas"
                      value={obj_anexo_cabecalho_to_edit?.obtidas === undefined ? '' : obj_anexo_cabecalho_to_edit?.obtidas}
                      onChange={onInputEditTableChange_cabecalho}
                      error={error_obtidas}
                      helperText={error_obtidas ? 'Apenas números são aceites' : ""}
                    />
                    :
                    <div style={{ paddingLeft: 5 }}>
                      {obj_anexo_cabecalho?.obtidas === undefined ? '' : obj_anexo_cabecalho?.obtidas}
                    </div>
                  }
                </div>
              </div>
              <Typography style={{ fontSize: 14, fontFamily: "candara", paddingTop: 30 }}>
                * Campos de preenchimento obrigatório
              </Typography>
            </Toolbar>
          }
        </TableContainer>
      </CustomThemeProvider>
      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
        onConfirm={handle_delete_cabecalho}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
      <ConfirmDialog
        open={open_dialog_eliminar_ficheiro}
        onClose={() => set_open_dialog_eliminar_ficheiro(false)}
        onConfirm={handleConfirmDelete}
        message="Deseja eliminar o documento?"
      />
      <ConfirmDialog
        open={open_dialog_editar_ficheiro}
        onClose={() => set_open_dialog_editar_ficheiro(false)}
        onConfirm={handleConfirmEdit}
        message="Ao enviar um novo ficheiro substitui o atual. Pretender continuar?"
      />
      <Modalshowpdf
        open_modal_show_pdf={open_modal_show_pdf}
        set_open_modal_show_pdf={set_open_modal_show_pdf}
        link_file={pdf_link}
      />
    </form>
  );
};
